import { Pipe, PipeTransform } from '@angular/core';
import { JsonPickService } from '../service/json-pick.service';



@Pipe({
  name: 'jsonParse'
})
export class JsonParsePipe implements PipeTransform {

  constructor(private jsonPickSevice: JsonPickService) {

  }


  transform(value: any, ...args: any[]): any {
    return this.jsonPickSevice.pick(value, args[0]);
  }
}
